import { useTranslate } from '@tolgee/react';
import { Section } from './Section';
import {
  SupplementalKnowledgeAiReply,
  SupplementalKnowledgeValue,
  SupplementalKnowledgeValueMessage,
} from 'services/api/supplementKnowledge';
import { PureBuyerQuestionContent } from './BuyerQuestion';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { getTranslateContent } from '../utils';
import { PureAIReplyContent, PureAIReplyMediaContent } from './AIReply';
import dayjs from 'lib/dayjs';

interface BuyerQuestionListProps {
  originQuestions: SupplementalKnowledgeValue['originQuestions'];
  buyerNick: string;
  aiReplyMap?: Record<string, SupplementalKnowledgeAiReply>;
}

interface BuyerQuestionItemProps {
  index: number;
  question: SupplementalKnowledgeValueMessage;
  buyerNick: string;
  aiReply?: SupplementalKnowledgeAiReply;
}

const BuyerQuestionItemAIReply = (props: {
  index: number;
  aiReply: SupplementalKnowledgeAiReply;
}) => {
  const { index, aiReply } = props;
  const { t } = useTranslate();
  const { replyContent, replyTime } = aiReply;
  const language = useSystemLanguageValue();
  const textAnswer = replyContent?.find((answer) => answer.msgType === 'TEXT');
  const textAnswerTranslate = getTranslateContent(language, textAnswer?.translateMap);

  return (
    <>
      <div className="flex items-center justify-between">
        <span>
          {t('AI回复')}
          {index + 1}
        </span>
        {!!replyTime && (
          <span className="text-xs text-[#777777]">
            {dayjs(replyTime).format('YYYY-MM-DD HH:mm:ss')}
          </span>
        )}
      </div>
      <PureAIReplyContent
        text={textAnswer?.message || ''}
        textTranslate={textAnswerTranslate}
        mediaExtra={<PureAIReplyMediaContent replyContent={replyContent} />}
      />
    </>
  );
};

const BuyerQuestionItem = (props: BuyerQuestionItemProps) => {
  const { index, question, buyerNick, aiReply } = props;
  const { t } = useTranslate();
  return (
    <div className="flex flex-col gap-2 bg-[var(--fett-erp-card-bg)] p-3 rounded-sm">
      <div>
        {t('买家问题')}
        {index + 1}
      </div>
      <PureBuyerQuestionContent buyerNick={buyerNick} question={question.message} />
      {!!aiReply && <BuyerQuestionItemAIReply index={index} aiReply={aiReply} />}
    </div>
  );
};

export const BuyerQuestionList = (props: BuyerQuestionListProps) => {
  const { originQuestions, buyerNick, aiReplyMap } = props;
  const { t } = useTranslate();

  return (
    <Section title={t('客服提交的AI回复记录x', { x: originQuestions?.length ?? 0 })}>
      <div className="flex flex-col gap-2 max-h-[220px] overflow-y-auto">
        {originQuestions?.map((question, index) => {
          const aiReply = aiReplyMap?.[question.messageId];
          return (
            <BuyerQuestionItem
              key={question.messageId}
              index={index}
              question={question}
              buyerNick={buyerNick}
              aiReply={aiReply}
            />
          );
        })}
      </div>
    </Section>
  );
};
